import { ProviderAddAllServicesRequest } from "../../../../models";
import { ProviderServiceModel } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";
export class ProviderServiceRepo extends BaseDataRepository<ProviderServiceModel> {
  protected baseUrl = 'providerservice';

  async insertAllServiceTypeServices(item: ProviderAddAllServicesRequest): Promise<boolean> {
    const response = await this.client.post(`${this.baseUrl}/${item.providerId}/addallservices`, item);
    return this.handleResponse<boolean>(response)!;
  }

  async getServicesByProviderId(providerId: number): Promise<ProviderServiceModel[]> {
    const response = await this.client.get(`${this.baseUrl}/getservicesbyproviderid/${providerId}`);
    return this.handleResponse<ProviderServiceModel[]>(response)!;
  }
}

export default ProviderServiceRepo;
